import { signInWithRedirect } from 'aws-amplify/auth'
import { getCachedAuthSession } from 'services/authSessionCache'
import Environment from './environment'

// Token refresh interval: 5 minutes
const fetchCognitoToken = async () => {
  if (!Environment.isAWSCognito()) return ''

  const session = await getCachedAuthSession()

  let idToken = session.tokens?.idToken

  if (!idToken) {
    await signInWithRedirect({ provider: { custom: 'AzureB2C' } })

    idToken = session.tokens?.idToken

    return idToken
  }

  return idToken
}

export default fetchCognitoToken
